
/**
 * validate login
 */
const validateLogin = function (submittingForm, setErrorMessage, isDoc, thisUser) {

    console.log("login validation");

    if (submittingForm.nameInput.value === "") {
        throwError(submittingForm.nameInput, "Bitte tragen Sie Ihren Nachnamen ein.", setErrorMessage);
        return false;
    }
    // check if last digit of name is empty
    else if (!validateLastDigit(submittingForm.nameInput.value)) {
        throwError(submittingForm.nameInput, "Die letzte Stelle Ihres Nachnamens ist eine Leerstelle.", setErrorMessage);
        return false;
    }
    // check if non doctors efn starts with 4 zeros
    else if (submittingForm.efnInput.value.substring(0, 2) !== "00" && !isDoc) {
        throwError(submittingForm.efnInput, "Ihre EFN muss mit 00 beginnen.", setErrorMessage);
        return false;
    }
    else if (submittingForm.countryInputLogin.value === "") {
        throwError(submittingForm.countryInputLogin, "Bitte tragen Sie Ihr Land ein.", setErrorMessage);
        return false;
    }
    else if (submittingForm.efnInput.value === "") {
        throwError(submittingForm.efnInput, "Bitte tragen Sie eine gültige Arzt-ID ein.", setErrorMessage);
        return false;
    }
    else if (!validateEfn(submittingForm, thisUser.Land, isDoc)) {
        throwError(submittingForm.efnInput, submittingForm.efnInput.value + " ist keine gültige Arzt-Identifikations-Nummer für Ihr Land.", setErrorMessage);
        return false;
    }
    else if (!validateDataprocessing(submittingForm)) {
        throwError(submittingForm.datenschutzAgreementInput, "Bitte stimmen Sie der Datenschutzerklärung zu.", setErrorMessage);
        return false;
    }
    else {
        return true;
    }
}

/**
 * validate registration
 */
const validateRegistration = function (submittingForm, setErrorMessage, thisUser, isDoc) {

    console.log("registration validation");

    if (submittingForm.nameInput.value === "") {
        throwError(submittingForm.nameInput, "Bitte tragen Sie Ihren Nachnamen ein.", setErrorMessage);
        return false;
    }
    // check if last digit of name is empty
    else if (!validateLastDigit(submittingForm.nameInput.value)) {
        throwError(submittingForm.nameInput, "Die letzte Stelle Ihres Nachnamens ist eine Leerstelle.", setErrorMessage);
        return false;
    }
    else if (submittingForm.firstnameInput.value === "") {
        throwError(submittingForm.firstnameInput, "Bitte tragen Sie Ihren Vornamen ein.", setErrorMessage);
        return false;
    }
    else if (submittingForm.streetInput.value === "") {
        throwError(submittingForm.streetInput, "Bitte tragen Sie Ihre vollständige Adresse ein.", setErrorMessage);
        return false;
    }
    else if (submittingForm.postalInput.value === "") {
        throwError(submittingForm.postalInput, "Bitte tragen Sie Ihre vollständige Adresse ein.", setErrorMessage);
        return false;
    }
    else if (submittingForm.cityInput.value === "") {
        throwError(submittingForm.cityInput, "Bitte tragen Sie Ihre vollständige Adresse ein.", setErrorMessage);
        return false;
    }
    else if (submittingForm.countryInput.value === "") {
        throwError(submittingForm.countryInput, "Bitte tragen Sie Ihre vollständige Adresse ein.", setErrorMessage);
        return false;
    }
    else if (submittingForm.specialfieldInput.value === "") {
        throwError(submittingForm.specialfieldInput, "Bitte geben Sie Ihr Fachgebiet an.", setErrorMessage);
        return false;
    }
    else if (!submittingForm["register-ambulant-input"].value && !submittingForm["register-stationaer-input"].value && !submittingForm["register-andere-input"].value) {
        throwError(submittingForm.querySelector("#arbeitsstaette-label"), "Bitte geben Sie mindestens eine Arbeitsstätte an.", setErrorMessage);
        return false;
    }
    else if (submittingForm.mailInput.value === "") {
        throwError(submittingForm.mailInput, "Bitte tragen Sie eine gültige E-Mail Adresse ein.", setErrorMessage);
        return false;
    }
    else if (!validateEmail(submittingForm.mailInput.value)) {
        throwError(submittingForm.mailInput, "Ungültiges E-Mail Format.", setErrorMessage);
        return false;
    }
    else if (submittingForm.efnInput.value === "") {
        throwError(submittingForm.efnInput, "Bitte tragen Sie eine gültige Arzt-ID ein.", setErrorMessage);
        return false;
    }
    else if (!validateEfn(submittingForm, thisUser.Land, isDoc)) {
        throwError(submittingForm.efnInput, submittingForm.efnInput.value + " ist keine gültige Arzt-Identifikations-Nummer für Ihr Land.", setErrorMessage);
        return false;
    }
    else if (!validateCourseAgreement(submittingForm)) {
        throwError(submittingForm.courseAgreementInput, "Bitte bestätigen Sie die Richtigkeit Ihrer Angaben.", setErrorMessage);
        return false;
    }
    else {
        console.log("validated registration");
        return true;
    }
}

/**
 * validate email
 */
function validateEmail(mail) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
}

/**
 * validate efn length
 */
function validateEfn(submittingForm, country, isDoc) {

    var efnLength;

    if (isDoc) {
        switch (country) {
            case "Deutschland":
                efnLength = 15;
                break;
            case "Österreich":
                efnLength = 8;
                break;

            default:
                // Andere -> nicht validieren
                return true;
        }
    }
    else {
        efnLength = 15;
    }


    if (submittingForm.efnInput.value.length !== efnLength) {
        return false;
    }
    else {
        //Luhn-Check
        if (!isValidLuhn(submittingForm.efnInput.value)) {
            return false;
        }
        return true;
    }
}

/* 
// -- Luhn Algorithmus zur Validierung von Identifikationsnummern*/
function isValidLuhn(number) {
    const digits = number.split('').map(digit => parseInt(digit, 10)); // Nummer in ein Array von Ziffern umwandeln

    for (let i = digits.length - 2; i >= 0; i -= 2) { // Von rechts nach links jede zweite Ziffer verarbeiten
        let doubled = digits[i] * 2; // Jede zweite Ziffer verdoppeln
        if (doubled > 9) doubled -= 9; // Wenn das Ergebnis größer als 9 ist, 9 subtrahieren
        digits[i] = doubled; // Die verdoppelte (und ggf. angepasste) Ziffer zurück ins Array setzen
    }

    const sum = digits.reduce((acc, digit) => acc + digit, 0); // Summe aller Ziffern berechnen
    console.log('Luhn sum: ', sum);
    console.log('Luhn valid: ', sum % 10 === 0);
    return sum % 10 === 0; // Gibt true zurück, wenn die Nummer gültig ist. Ansonsten false. 
}

// Beispielaufruf
//const number = "123456789012345";
//console.log(isValidLuhn(number)); // Gibt true oder false zurück



/**
 * validate mandatory agreement
 */
function validateCourseAgreement(submittingForm) {
    if (!submittingForm.courseAgreementInput.checked) {
        return false;
    }
    else {
        return true;
    }
}
function validateDataprocessing(submittingForm) {
    if (!submittingForm.datenschutzAgreementInput.checked) {
        return false;
    }
    else {
        return true;
    }
}
/**
 * Check if last digit is no space
 * @param {String} string 
 * @returns true or false
 */
function validateLastDigit(string) {
    var lastDigit = string[string.length - 1];
    if (lastDigit === " ") return false;
    else return true;
}


function throwError(target, errorMessage, setErrorMessage) {
    // remove wrong-input class
    var allWrongInputs = document.querySelectorAll(".wrong-input");
    for (let i = 0; i < allWrongInputs.length; i++) {
        allWrongInputs[i].classList.remove("wrong-input");
    }
    // add wrong input-class to target
    if (target) target.classList.add("wrong-input");
    // set error message
    setErrorMessage(errorMessage);
}

export { validateLogin, validateRegistration, validateEmail }